import {
  Alert, Avatar, Stack, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Typography
} from '@mui/material';
import { useAppSelector } from '../../../hooks';
import type { PointsRow } from '../../../reducers/points';

function PointsTable({ rows }: { rows: PointsRow[] }) {
  return (
    <TableContainer sx={{ maxWidth: 420 }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ width: 56 }} />
            <TableCell>Gracz</TableCell>
            <TableCell align="right">Punkty</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, index) => (
            <TableRow key={row._id} hover>
              <TableCell>
                <Avatar sx={{
                  width: 32,
                  height: 32,
                  bgcolor: index === 0 ? 'primary.main' : 'grey.500'
                }}
                >{row.name.slice(0, 1).toUpperCase()}
                </Avatar>
              </TableCell>
              <TableCell>{row.name}</TableCell>
              <TableCell align="right">{row.points}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default function StepSuccess() {
  const { pointsResults, pointsPerPeriod } = useAppSelector((s) => s.points);
  return (
    <Stack className="stepSuccess" spacing={2} alignItems="flex-start">
      <Alert severity="success" sx={{ width: '100%', maxWidth: 560 }}>
        Dodano punkty. Przyrost punktów danego dnia:
      </Alert>
      <PointsTable rows={pointsResults} />
      <Typography variant="subtitle1">Punkty miesiąca</Typography>
      <PointsTable rows={pointsPerPeriod} />
    </Stack>
  );
}
